import PropTypes from 'prop-types';
import React from 'react';
import { Col, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import ConvertedUnits from 'src/components/ConvertedUnits';
import { MODULE_TRANSACTIONS_FILTER_STATES } from 'src/constants/filters';
import { formatThreeDecimalsNumber } from 'src/utils/conversions';

import TransactionsList from './transactions-list';

const TransactionsTableSection = ({
  title,
  summary,
  units,
  transactions,
  containers,
  amountLeftToReclaim,
  updateReconciledTransactions,
  onToggleEdit,
  editResetKey,
  isEditable = false,
  isEditing = false,
  batchActionsProps,
}) => {
  const tableHeaderTitle = title === MODULE_TRANSACTIONS_FILTER_STATES.PENDING ? 'to be claimed' : 'Reconciled';

  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: '16px' }}>
        <h6 className="mb-0 flex-1">
          {title} [
          <ConvertedUnits
            displayZero
            quantity={summary > 0 ? formatThreeDecimalsNumber(summary): 0}
            units={units}
          />&nbsp;
          {tableHeaderTitle}]
        </h6>
        {isEditable && (
          <button type="button" className={`btn mt20 ${!isEditing ? 'btn-primary' : 'module-transactions-btn'}`} onClick={onToggleEdit}>
            {!isEditing ? 'Edit' : 'Cancel'}
          </button>
        )}
      </div>
      <ListGroup>
        <ListGroupItem className="resource-list-item-card-header">
          <Row>
            <Col xs={7}>Name</Col>
            <Col xs={5}>Amount</Col>
          </Row>
        </ListGroupItem>
        <TransactionsList
          transactions={transactions}
          containers={containers}
          units={units}
          amountLeftToReclaim={amountLeftToReclaim}
          updateReconciledTransactions={updateReconciledTransactions}
          isEditing={isEditing}
          editResetKey={editResetKey}
          batchActionsProps={batchActionsProps}
          emptyMessage="No transactions match the current filters."
        />
      </ListGroup>
    </div>
  );
};

TransactionsTableSection.propTypes = {
  title: PropTypes.string.isRequired,
  summary: PropTypes.number.isRequired,
  units: PropTypes.string,
  batchActionsProps: PropTypes.shape({}).isRequired,
  transactions: PropTypes.array.isRequired,
  containers: PropTypes.object.isRequired,
  isEditable: PropTypes.bool,
  isEditing: PropTypes.bool,
  editResetKey: PropTypes.number,
  onToggleEdit: PropTypes.func,
  amountLeftToReclaim: PropTypes.number,
  updateReconciledTransactions: PropTypes.func,
};

export default TransactionsTableSection;
